import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../app/store";
import { showToast } from "../app/slice/toastsSlice";
import AuthService from "../services/auth.service";
import { fetchWallet } from "../app/slice/walletSlice";
import { useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';

interface Props {
  isGameActive: boolean;
  isBetOpen: any;
  id: number,
  multiplier: string
  isCrashed: any,
  totalUsers: number
}

interface Bet {
  betAmount: number;
  type: string;
  id: number
}

type AutoPlaySettings = {
  totalRounds: number;
  stopLoss: number;
  stopProfit: number;
  stopSingleWin: number;
  autoCashOut: number;
};

const AviatorBoard: React.FC<Props> = ({ id, isGameActive, isBetOpen, isCrashed, multiplier, totalUsers }) => {
  const walletAmount = useSelector((state: RootState) => state.wallet.wallet);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [waitMessage, setWaitMessage] = useState("");
  const [showAll, setShowAll] = useState(false);
  const [progress, setProgress] = useState<number>(0);
  const [queuedFormData, setQueuedFormData] = useState<Bet | null>(null);
  const [isBetPlaced, setIsBetPlaced] = useState(false);
  const [isCashout, setIsCashout] = useState(false);
  const [isAutoBetPlaced, setIsAutoBetPlaced] = useState(false);

  const [gameLoading, setGameLoading] = useState(true);
  const [maxRange, setMaxRange] = useState<number>(0);
  const [totalMultiplier, setTotalMultiplier] = useState<number>(0);
  const [betAmount, setBetAmount] = useState<any | Number>(0);
  const [wallet, setWallet] = useState<any | Number>(walletAmount);
  const dispatch = useDispatch<AppDispatch>();
  const [isAutoCall, setIsAutoCall] = useState<boolean>(false);
  const [betType, setBetType] = useState<any>('manual');
  const [gameData, setGameData] = useState<any>();

  // const [multiplier, setMultiplier] = useState("");
  const [showAutoBetModal, setShowAutoBetModal] = useState<boolean>(false);
  const [noOfRounds, setNoOfRounds] = useState<number>(0);
  const [autoCashout, setAutoCashout] = useState<number>(0);
  const [onDecrease, setOnDecrease] = useState<number>(0);
  const [onIncrease, setOnIncrease] = useState<number>(0);
  const [singleExceed, setSingleExceed] = useState<number>(0);
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [profit, setProfit] = useState(0);
  const navigate = useNavigate();

  const [settings, setSettings] = useState<AutoPlaySettings>({
    totalRounds: 0,
    stopLoss: 0,
    stopProfit: 0,
    stopSingleWin: 0,
    autoCashOut: 0
  });

  useEffect(() => {
    setWallet(walletAmount);
  }, [walletAmount]);

  const handleAmountMulti = (event: any, amt: number) => {
    event.preventDefault();
    if (amt > wallet?.user_combined_wallet) {
      setBetAmount(wallet?.user_combined_wallet);
      return;
    }
    setBetAmount(Number(amt).toFixed(2));
  };

  const handleAmountAdd = (event: any, amt: number) => {
    event.preventDefault();
    setMessage('');
    if ((Number(betAmount) + amt) > wallet?.user_combined_wallet) {
      return;
    }
    setBetAmount((Number(betAmount) + amt).toFixed(2));
  };

  const onChangeAmount = (e: any) => {
    if (!isNaN(e.target.value)) {
      setBetAmount(e.target.value);
    }
  };


  useEffect(() => {
    if (isCrashed) {      
      setIsCashout(false);
      setIsBetPlaced(false);

      if (isAutoCall && currentStep === 0) {
        setIsAutoCall(false);
        setQueuedFormData(null);
        handleCloseAutobet("");
        setIsAutoBetPlaced(false);
      }

      if (isAutoCall && currentStep >= 0 && isAutoBetPlaced && isCashout) {
        setProfit((prevProfit) => {
          const updatedProfit = prevProfit - betAmount;
          if (updatedProfit <= settings?.stopLoss && settings?.stopLoss > 0) {
            handleCloseAutobet("");
          }          
          return updatedProfit;
        });
      }
    }

  }, [isCrashed]);

  useEffect(() => {
    if (isCashout && isAutoCall && Number(settings?.autoCashOut) > 0 && Number(multiplier) === Number(settings?.autoCashOut)) {
      handleCashout(gameData?.betId);
    }

  }, [multiplier]);


  useEffect(() => {    
    if (!isAutoCall) {
      if (isGameActive && queuedFormData && (isBetOpen === 0 || isBetOpen === null)) {
        setWaitMessage("");
        handleSubmitGame(queuedFormData);
        setTimeout(() => {
          setQueuedFormData(null);
        }, 5000);

        // Clear the queue after submission
      }

    } else {
      if (isGameActive && (isBetOpen === 0 || isBetOpen === null) && (currentStep <= settings?.totalRounds) && (currentStep > 0)) {
        handleSubmitGame(queuedFormData);
        setIsAutoBetPlaced(true);
        if (currentStep >= 1) {
          setCurrentStep((prev) => prev - 1);
        }

      }

    }
  }, [isGameActive, queuedFormData, isBetOpen]);


  function handlePlaceBet() {
    if (!isGameActive) {
      let toast = {
        type: 'error',
        title: 'Error',
        message: 'No Active game found'
      }
      dispatch(showToast(toast));

      return;
    }
    if (Number(betAmount) > Number(wallet?.user_combined_wallet)) {
      let toast = {
        type: 'error',
        title: 'Error',
        message: 'Insufficient Balance'
      }
      dispatch(showToast(toast));

      return;
    }

    let formData = {
      betAmount: betAmount,
      type: betType,
      id: id
    }

    if (isGameActive && (isBetOpen === null || isBetOpen === 0)) {
      setLoading(true);
      handleSubmitGame(formData);

    } else {

      setIsBetPlaced(true);
      setWaitMessage("waiting for next round");
      setQueuedFormData(formData);
    }

  }


  function handleSubmitGame(data: any) {
    AuthService.PlaceBetPlane(data)
      .then(
        (response) => {
          // console.log(response);
          if (response.status === 200) {
            dispatch(fetchWallet());
            setGameData(response?.data);
            setIsBetPlaced(true);
            setIsCashout(true);

          } else {
            let toast = {
              type: 'error',
              title: 'Error',
              message: response?.message
            }
            dispatch(showToast(toast));
            setMessage(response?.message);
          }
        }
      ).catch((error) => {
        const message = error?.response?.data?.error_description;
        setMessage(message);
        if (error?.response?.data?.status === 401) {
          localStorage.removeItem("w_token");
          navigate('/login');
        } else {
          let toast = {
            type: 'error',
            title: 'Error',
            message: message
          }
          dispatch(showToast(toast));
        }
      }).finally(() => {
        setLoading(false);
      });
  }

  function handleCancelBet(bid: any) {
    setLoading(true);
    if ((isBetOpen === 1) && queuedFormData) {
      setWaitMessage("");
      setQueuedFormData(null);
      setIsBetPlaced(false);
      // setNoOfRounds(0);
      handleResetAutoBet();
      setLoading(false);
      setProfit(0);
      return;
    }
    AuthService.CancelBetPlane({ id: bid })
      .then(
        (response) => {
          // console.log(response);
          if (response.status === 200) {
            dispatch(fetchWallet());
            setIsBetPlaced(false);
            setWaitMessage("");
            setGameData(undefined);
          } else {
            let toast = {
              type: 'error',
              title: 'Error',
              message: response?.message
            }
            dispatch(showToast(toast));
            setMessage(response?.message);
          }
        }
      ).catch((error) => {
        const message = error?.response?.data?.error_description;
        setMessage(message);
        if (error?.response?.data?.status === 401) {
          localStorage.removeItem("w_token");
          navigate('/login');
        } else {
          let toast = {
            type: 'error',
            title: 'Error',
            message: message
          }
          dispatch(showToast(toast));
        }
      }).finally(() => {
        setLoading(false);
      });

  }

  function handleCashout(bid: any) {
    setLoading(true);
    let formData = {
      id: bid,
      timestamp: Date.now()
    }
    AuthService.CashoutPlane(formData)
      .then(
        (response) => {
          // console.log(response);
          if (response.status === 200) {
            setIsBetPlaced(false);
            setIsCashout(false);
            let finalPayout = (response?.data?.final_payout).toFixed(2);
            let toast = {
              type: 'success',
              title: 'Success',
              message: `You have cashout ${finalPayout}`
            }
            dispatch(showToast(toast));
            dispatch(fetchWallet());

            if (isAutoCall) {

              if (isAutoBetPlaced) {                
                if ((settings?.stopSingleWin <= (finalPayout-betAmount)) && settings?.stopSingleWin > 0) {
                  handleCloseAutobet("");
                }

                setProfit((prevProfit:any) => {
                  const updatedProfit = prevProfit + (finalPayout - betAmount);

                  if (updatedProfit >= settings?.stopProfit && settings?.stopProfit > 0) {
                    handleCloseAutobet("");
                  }
                  return updatedProfit;
                });
              }
            }
          } else {
            let toast = {
              type: 'error',
              title: 'Error',
              message: response?.message
            }
            dispatch(showToast(toast));
            setMessage(response?.message);
          }
        }
      ).catch((error) => {
        const message = error?.response?.data?.error_description;
        setMessage(message);
        if (error?.response?.data?.status === 401) {
          localStorage.removeItem("w_token");
          navigate('/login');
        } else {
          let toast = {
            type: 'error',
            title: 'Error',
            message: message
          }
          dispatch(showToast(toast));
        }
      }).finally(() => {
        setLoading(false);
      });


  }



  const handleCloseAutobet = (e: any) => {
    const checked = e?.target?.checked;    
    setShowAutoBetModal(checked ? true : false);
    setIsAutoCall(false);    
    setCurrentStep(0);
    handleResetAutoBet();
    setIsAutoBetPlaced(false);
    setQueuedFormData(null);
    setProfit(0);
    if(checked===undefined){
      setIsBetPlaced(false);
    }
  }


  function handleStartAutoBet() {
    if (settings?.totalRounds === 0 || String(settings?.totalRounds)==='') {
      let toast = {
        type: 'error',
        title: 'Error',
        message: 'Please enter no. of rounds'
      }
      dispatch(showToast(toast));
      return;
    }

    if (settings?.autoCashOut <= 1 && settings?.autoCashOut > 0) {
      let toast = {
        type: 'error',
        title: 'Error',
        message: 'Auto cashout should be greater than 1'
      }
      dispatch(showToast(toast));
      return;
    }

    let formData = {
      betAmount: betAmount,
      type: betType,
      id: id
    }

    setIsBetPlaced(true);
    setWaitMessage("waiting for next round");
    setQueuedFormData(formData);
    setIsAutoCall(true);
    setShowAutoBetModal(false);
    setCurrentStep(settings?.totalRounds);
    setBetType('auto');
    setProfit(0);

  }

  function handleResetAutoBet() {
    setIsAutoBetPlaced(false);
    setProfit(0);
    setSettings({
      totalRounds: 0,
      stopLoss: 0,
      stopProfit: 0,
      stopSingleWin: 0,
      autoCashOut: 0
    });
 
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;     
    setSettings((prev) => ({
      ...prev,
      [name]: isNaN(parseFloat(value)) ? "" : parseFloat(value) ,
    }));
  
  };

  return (
    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-2 planeped">
      <div className="row aviBg">
        <div className="col-12 mb-my mt-2 amountMt">
          <label htmlFor={`amount${id}`}>Amount</label>
          <div className='amountInpunt'>
            <div className='d-flex align-items-center' style={{ height: '100%', width: '100%' }}>
              <p>₹</p>
              <input type="text" id={`amount${id}`} placeholder="0" value={betAmount} onChange={(e) => onChangeAmount(e)} maxLength={10} autoComplete="off" readOnly={!isGameActive || loading || isBetPlaced || isAutoCall} />
            </div>
            <div className='d-flex align-items-center justify-content-end' style={{ height: '100%', width: '100%' }}>
              <button onClick={event => handleAmountMulti(event, betAmount / 2)} disabled={!isGameActive || loading || isBetPlaced || isAutoCall}>1/2</button>
              <button onClick={event => handleAmountMulti(event, betAmount * 2)} disabled={!isGameActive || loading || isBetPlaced || isAutoCall}>2x</button>
              <button onClick={event => handleAmountMulti(event, wallet?.user_combined_wallet)} disabled={!isGameActive || loading || isBetPlaced || isAutoCall}>All In</button>

            </div>
          </div>
        </div>
        <div className="col-12 mb-my d-flex">
          <div className="betAmoutAvi">
            <button onClick={event => handleAmountAdd(event, 100)} disabled={!isGameActive || loading || isBetPlaced || isAutoCall}><span>100</span></button>
            <button onClick={event => handleAmountAdd(event, 500)} disabled={!isGameActive || loading || isBetPlaced || isAutoCall}><span>500</span></button>
            <button onClick={event => handleAmountAdd(event, 1000)} disabled={!isGameActive || loading || isBetPlaced || isAutoCall}><span>1000</span></button>
            <button onClick={event => handleAmountAdd(event, 2000)} disabled={!isGameActive || loading || isBetPlaced || isAutoCall}><span>2000</span></button>
            <button onClick={event => handleAmountAdd(event, 2500)} disabled={!isGameActive || loading || isBetPlaced || isAutoCall}><span>2500</span></button>
          </div>
        </div>
        <div className="col-6 mb-my">
          <div className="switch_main d-flex align-items-center">
            <label htmlFor={`autoBtn${id}`}>{isAutoCall ? 'Stop Auto Bet (' + currentStep + ')' : 'Auto Bet'}</label>
            <div className="form-check form-switch">
              <input className="form-check-input custom-switch-xl" type="checkbox" id={`autoBtn${id}`} onChange={handleCloseAutobet} checked={isAutoCall} disabled={loading} />
            </div>
          </div>
        </div>
        {settings?.autoCashOut > 0 &&
          <div className="col-6 mb-my">
            <div className="switch_main d-flex align-items-center justify-content-lg-end">
              <label>Auto Cash Out {settings?.autoCashOut}</label>
            </div>
          </div>
        }
        <div className="col-12 mb-my d-flex align-items-center justify-content-end">
          {isGameActive && (isBetPlaced || queuedFormData) ?
            isCashout && Number(isBetOpen) === 1 ?
              <button className='betBtn' onClick={!loading ? (e) => handleCashout(gameData?.betId) : undefined} disabled={loading ? true : false}>
                {loading ?
                  <>
                    Please wait...
                  </>
                  :
                  <>
                    Cashout {Number(betAmount) >= 100 ? Math.floor(Number(betAmount) * Number(multiplier)) : (Number(betAmount) * Number(multiplier)).toFixed(2)} INR
                  </>
                }
              </button>
              :
              <button className='betBtn betBtnCancel' onClick={(e) => (isAutoCall ? handleCloseAutobet(e) : handleCancelBet(gameData?.betId))} disabled={loading ? true : false}>
                {loading ?
                  <>
                    Please wait...
                  </>
                  :
                  <>
                    Cancel {Number(isBetOpen) === 1 && isGameActive && waitMessage}
                  </>
                }
              </button>

            :
            isBetPlaced || queuedFormData ?
              <button className='betBtn betBtnCancel' onClick={(e) => (isAutoCall ? handleCloseAutobet(e) : handleCancelBet(gameData?.betId))} disabled={loading ? true : false}>
                {loading ?
                  <>
                    Please wait...
                  </>
                  :
                  <>
                    Cancel {Number(isBetOpen) === 1 && isGameActive && waitMessage}
                  </>
                }
              </button>
              :
              <button className='betBtn' onClick={!loading ? handlePlaceBet : undefined} disabled={loading || !isGameActive ? true : false}>
                {loading ?
                  <>
                    Please wait...
                  </>
                  :
                  <>
                    Place Bet
                  </>
                }
              </button>
          }

          <p className="userUse">
            <svg className="me-1" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M0.493469 11.5366C0.493469 9.2459 2.35043 7.38895 4.6411 7.38895C6.93179 7.38895 8.78874 9.2459 8.78874 11.5366H0.493469ZM4.6411 6.8705C2.92243 6.8705 1.53038 5.47845 1.53038 3.75977C1.53038 2.0411 2.92243 0.649048 4.6411 0.649048C6.35978 0.649048 7.75183 2.0411 7.75183 3.75977C7.75183 5.47845 6.35978 6.8705 4.6411 6.8705ZM8.45838 8.02831C10.058 8.43711 11.2607 9.83787 11.3725 11.5366H9.82564C9.82564 10.1835 9.30729 8.95152 8.45838 8.02831ZM7.4097 6.84815C8.25618 6.08877 8.78874 4.98647 8.78874 3.75977C8.78874 3.02495 8.59763 2.33475 8.26245 1.73618C9.44992 1.97316 10.3441 3.02079 10.3441 4.27823C10.3441 5.71046 9.18406 6.8705 7.75183 6.8705C7.63585 6.8705 7.52163 6.86288 7.4097 6.84815Z" fill="white" />
            </svg>
            {totalUsers ? totalUsers : 0}
          </p>
        </div>
      </div>

      <Modal show={showAutoBetModal} className='selectCurrency modal-slide-up bg-dark-Bet autoBetModal' data-backdrop="static">
        <Modal.Body>
          <div className="row mb-2">
            <div className="col-10">
              <h1 className="text-white m-0 d-flex align-items-center" style={{ height: '100%' }}>Auto-play Bet</h1>
            </div>
            <div className="col-2">
              <button style={{ background: 'none', border: 'none' }} onClick={(e: any) => handleCloseAutobet(e)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z" fill="#CCCCCC"></path></svg>
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-12 mb-my">
              <label htmlFor='no_of_bet'>No.of Rounds</label>
              <div className='amountInpunt'>
                <div className='d-flex align-items-center' style={{ height: '100%', width: '100%' }}>
                  <input type="number" id="no_of_bet" name="totalRounds" value={settings?.totalRounds} autoComplete='off' min={0} max={100} onChange={handleChange} />
                </div>
              </div>
            </div>
            <div className="col-12 mb-my">
              <label htmlFor='decrease'> Stop if cash decreases by </label>
              <div className='amountInpunt'>
                <div className='d-flex align-items-center' style={{ height: '100%', width: '100%' }}>
                  <input type="number" id="decrease" name="stopLoss" value={settings?.stopLoss} min={0} onChange={handleChange} inputMode="decimal" />
                </div>
                <div className='d-flex align-items-center justify-content-end' style={{ height: '100%', }}>
                  <button style={{ background: 'none', color: '#fff' }}>
                    INR
                  </button>
                </div>
              </div>
            </div>
            <div className="col-12 mb-my">
              <label htmlFor='increases'> Stop if cash increases by </label>
              <div className='amountInpunt'>
                <div className='d-flex align-items-center' style={{ height: '100%', width: '100%' }}>
                  <input type="number" id="increases" name="stopProfit" value={settings?.stopProfit} min={0} onChange={handleChange} />

                </div>
                <div className='d-flex align-items-center justify-content-end' style={{ height: '100%', }}>
                  <button style={{ background: 'none', color: '#fff' }}>
                    INR
                  </button>
                </div>
              </div>
            </div>
            <div className="col-12 mb-my">
              <div className='d-flex justify-content-between'>
                <label htmlFor='stop_on_profit'> Stop if single win exceeds</label>
                <label>00000000000  USDT</label>
              </div>
              <div className='amountInpunt'>
                <div className='d-flex align-items-center' style={{ height: '100%', width: '100%' }}>
                  <input type="number" id="stop_on_profit" name="stopSingleWin" value={settings?.stopSingleWin} min={0} onChange={handleChange} />
                </div>
                <div className='d-flex align-items-center justify-content-end' style={{ height: '100%', }}>
                  <button style={{ background: 'none', color: '#fff' }}>
                    INR
                  </button>
                </div>
              </div>
            </div>
            <div className="col-12 mb-my">
              <label htmlFor='no_of_bet'>Auto Cash Out</label>
              <div className='amountInpunt'>
                <div className='d-flex align-items-center' style={{ height: '100%', width: '100%' }}>
                  <input type="number" id="no_of_bet" name="autoCashOut" value={settings?.autoCashOut} autoComplete='off' step="0.10" min={1} max={100} onChange={handleChange} />
                </div>
              </div>
            </div>
            <div className="col-6 mb-my mt-2">
              <button className='Cashout' onClick={handleResetAutoBet}>Reset</button>
            </div>
            <div className="col-6 mb-my mt-2">
              <button className='betBtn' onClick={handleStartAutoBet}>Start</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>

  );
};

export default AviatorBoard;


